import ScrollOut from "scroll-out";

// Scripts to fire once dom has loaded
document.addEventListener("DOMContentLoaded", () => {

	// Open Menu
    const navTrigger = document.querySelector('.js-open-nav');
    const projectWrapper = document.body;

    // Toggle Menu
    bindEvent(navTrigger, "click", function() {
        this.classList.toggle('is-active');
        projectWrapper.classList.toggle('js-is-opened');
    });

    const primaryButton = document.querySelectorAll('.button.primary');

    if (primaryButton) {
        primaryButton.forEach(button => button.innerHTML = '<div><span>' + button.textContent.trim().split('').join('</span><span>') + '</span></div>');
    }

    ScrollOut({
      once: true,
      threshold: 0.3,
    });

    const infoWrapper = document.querySelector('.info-wrapper.extra-items');
    const expandBtn = document.getElementById('expand-btn');

    if (infoWrapper) {
        bindEvent(expandBtn, "click", function() {
            infoWrapper.classList.toggle('open');

             if (expandBtn.innerHTML === "<div><span>E</span><span>x</span><span>p</span><span>a</span><span>n</span><span>d</span></div>") {
                    expandBtn.innerHTML = "<div><span>S</span><span>h</span><span>r</span><span>i</span><span>n</span><span>k</span></div>";
              } else {
                    expandBtn.innerHTML = "<div><span>E</span><span>x</span><span>p</span><span>a</span><span>n</span><span>d</span></div>";
              }
        });
    }

	// Accordions
    const accordionItems = document.querySelectorAll('[data-accordion-item]');

    if (accordionItems.length) {
        accordionItems.forEach(function(accordion) {
            const accordionLink = accordion.firstElementChild;
            bindEvent(accordionLink, 'click', toggleAccordion);
        });
    }

    function toggleAccordion(e) {
        const link = this.closest('[data-accordion-link]');
        const parent = link.closest('[data-accordion]');
        const content = parent.querySelectorAll('[data-accordion-content]');

        content.forEach(function(content) {
            if (content.previousElementSibling === link) {
                content.classList.toggle('is-active');
                link.classList.toggle('is-active');
                link.setAttribute('aria-expanded', link.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
            }
            else {
                if(!("accordionAllowMultiple" in content.parentNode.dataset)) {
                    content.classList.remove('is-active');
                    content.previousElementSibling.classList.remove('is-active');
                    content.previousElementSibling.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }


	//Click function
    function bindEvent(el, eventName, eventHandler) {
	    if (el.addEventListener){
	        el.addEventListener(eventName, eventHandler, false);
	    } else if (el.attachEvent){
	        el.attachEvent('on'+eventName, eventHandler);
	    }
	}

    //Choose svg border based on first section background for simple banner
    const simpleBanner = document.querySelector('section.section-simple-banner')
    if (simpleBanner) {
        const nextSection = document.querySelector('section.section-simple-banner + section')
        const isCream = window.getComputedStyle(nextSection).backgroundColor === 'rgb(249, 244, 240)'
        if (isCream)
        simpleBanner.style.cssText = simpleBanner.style.cssText.replace('line.svg', 'line-cream.svg')
    }
})
